import axios from 'axios';
import {useMutation} from 'react-query';
import {publicAxios} from 'config/RequestInterceptor';

let config = {
    headers: {
        'Content-Type': 'application/json',
    },
}

interface LoginUser {
    identifier: string | any;
    password: string
}

export const useLoginMutation = () => {
    const loginUser = async (values: LoginUser) => {
        const baseURL = process.env.REACT_APP_BASE_URL;
        const queryString = Object.keys(values)
            // @ts-ignore
            .map((key) => key + '=' + values[key])
            .join('&');

        // return await axios.post(`${baseURL}/wp-json/jwt-auth/v1/token`, values, config);
        return await publicAxios.post(`/api/auth/local`, values);
    };
    return useMutation('login', loginUser);
};

export default useLoginMutation;
